import { useClient } from '../../../../api/api-client';
import { useQueryCall } from '../../../../api/react-client';
import { FALLBACK_COMPLAINT_TYPES, IVA_POLICIES_ENDPOINTS } from './constants';

const toOption = (complaintType) => ({
  label: complaintType,
  value: complaintType,
});

const FALLBACK_OPTIONS = FALLBACK_COMPLAINT_TYPES.map(toOption);

export const useComplaintTypes = () => {
  const client = useClient();

  const { data: metadata, isLoading } = useQueryCall(
    // No retries: agents without pickup-policy access get a 403, and retrying
    // would only delay falling back to the hardcoded list.
    { retry: false },
    IVA_POLICIES_ENDPOINTS.METADATA,
    ['pickup_policy', 'metadata'],
    () => client(IVA_POLICIES_ENDPOINTS.METADATA),
  );

  const fetched =
    metadata?.complaint_types?.map((ct) => toOption(ct.complaint_type)) || [];

  // Covers errors too: a failed query leaves metadata undefined, so fetched is empty.
  const options = fetched.length > 0 ? fetched : FALLBACK_OPTIONS;

  return { options, isLoading };
};
